import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const ALLOWED_KEYS = [
  'Tab',
  'Backspace',
  'ArrowLeft',
  'ArrowRight',
  'Delete',
  '+',
];

const ALLOWED_CTRL_KEYS = ['a', 'A', 'v', 'V', 'c', 'C', 'x', 'X'];

const isValidControlEvent = (event: KeyboardEvent) =>
  event.ctrlKey && ALLOWED_CTRL_KEYS.includes(event.key);

@Component({
  selector: 'nx-ng-mobile-phone',
  templateUrl: './mobile-phone.component.html',
  styleUrls: ['./mobile-phone.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MobilePhoneComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobilePhoneComponent implements ControlValueAccessor {
  @Input()
  id = '';
  @Input()
  label = '';
  @Input()
  placeholder = '';
  @Input()
  errorText = '';
  @Input()
  isRequired = false;

  private localValue = '';
  private touched = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  set value(value: string) {
    this.localValue = value;
    this.onChange(value);
  }

  get value(): string {
    return `${this.localValue}`;
  }

  onChange = (event: any) => {};
  onTouch = () => {};

  writeValue(value: any) {
    this.localValue = value;

    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  get errorId() {
    return `${this.id}-error`;
  }

  get hasError() {
    return this.errorText?.length > 0;
  }

  markAsTouched() {
    if (!this.touched) {
      this.touched = true;
    }
    this.onTouch();
  }

  handleKeydown(event: KeyboardEvent) {
    if (
      (event.key < '0' || event.key > '9') &&
      !ALLOWED_KEYS.includes(event.key) &&
      !isValidControlEvent(event)
    ) {
      event.preventDefault();
    }
  }
}
